import React from 'react';

import { useNavigate } from 'react-router-dom';

export interface BreadcrumbItemProps {
  label: string;
  link?: string;
  activeRoute?: boolean;
}

const BreadcrumbItem = ({ label, link, activeRoute }: BreadcrumbItemProps) => {
  const navigate = useNavigate();

  const goToRoute = () => {
    navigate(link ?? '');
  };

  return (
    <div className="breadcrumb-item">
      {!activeRoute && link ? (
        <a className="text-link" role="link" onClick={goToRoute} tabIndex={0} onKeyDown={goToRoute}>
          {label}
        </a>
      ) : (
        <span>{label}</span>
      )}
      {!activeRoute && <span className="breadcrumb-separator">/</span>}
    </div>
  );
};

export default BreadcrumbItem;
